<section class="hero">
  <div class="hero-inner text-center">
    <div class="hero-chip">
      <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
      Software para administración y control de accesos
    </div>
    <h1>La plataforma que tu <span class="grad">fraccionamiento</span> merece</h1>
    <p class="hero-sub mx-auto">Accesos automatizados, seguridad y comunidad en una sola app. Moderniza tu privada con tecnología respaldada por AWS y Google Cloud.</p>
    <div class="hero-actions d-flex gap-3 justify-content-center flex-wrap">
      <a class="btn-primary" [routerLink]="['/']" [fragment]="'contact'">Solicitar demostración</a>
      <a class="btn-glass" [routerLink]="['/']" [fragment]="'features'">Ver características</a>
    </div>
  </div>

  <div class="hero-floaters">
    <div class="floater">
      <div class="floater-ico f-blue">
        <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>
      </div>
      <h4>Accesos de residentes automatizados</h4>
      <p>Entradas y salidas automáticas mediante RFID, UHF o código QR sin intervención del guardia.</p>
    </div>
    <div class="floater">
      <div class="floater-ico f-peach">
        <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
      </div>
      <h4>Control de visitas con QR</h4>
      <p>Acceso autorizado de visitas mediante código QR con notificación instantánea al residente.</p>
    </div>
    <div class="floater">
      <div class="floater-ico f-mint">
        <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      </div>
      <h4>Comunidad activa</h4>
      <p>Chat, anuncios, encuestas y reservación de amenidades.</p>
    </div>
  </div>
</section>
